import { SVGProps } from 'react'

const LinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={
      {
        enableBackground: 'new 0 0 60 60'
      } as any
    }
    viewBox="0 0 60 60"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path d="M30 9C18.4 9 9 18.4 9 30s9.4 21 21 21 21-9.4 21-21S41.6 9 30 9zm-5.2 30.4h-4.3v-14h4.3v14zm-2.2-15.9c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6zm18.5 15.9h-4.3V32c0-2-.8-3.1-2.4-3.1-1.7 0-2.6 1.2-2.6 3.1v7.4h-4.2v-14h4.2v1.9S33.1 25 36 25c3 0 5.1 1.8 5.1 5.6v8.8z" />
  </svg>
)
export default LinkedIn
